import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';

export const ServiceOutageBanner = () => {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let live = true;
    const load = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ops/service-outage`, { credentials: 'include' });
        if (res.ok && live) setStatus(await res.json());
      } catch (_) { /* Do not invent outage state from a device connection error. */ }
    };
    load(); window.addEventListener('focus', load); window.addEventListener('online', load);
    return () => { live = false; window.removeEventListener('focus', load); window.removeEventListener('online', load); };
  }, []);
  if (!status?.active) return null;
  return <aside role="status" className="flex items-start gap-3 border-y border-amber-500 bg-amber-50 text-amber-950 px-4 py-3 min-w-0" data-testid="service-outage-banner">
    <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
    <div className="min-w-0"><p className="font-bold text-sm" data-testid="service-outage-banner-title">NECS app outage · {status.property_name}</p>
      <p className="text-sm whitespace-pre-wrap break-words [overflow-wrap:anywhere]" data-testid="service-outage-banner-message">{status.message}</p></div>
  </aside>;
};